document.addEventListener('DOMContentLoaded', function () {
  /* FAQ ACCORDION */
  document.querySelectorAll('.lc-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.lc-faq-item.open').forEach(function (o) {
        o.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });
  /* TOC SCROLL-SPY */
  var sections = document.querySelectorAll('.lc-content section[id]');
  var tocLinks = document.querySelectorAll('.lc-toc a');
  if (sections.length && tocLinks.length) {
    function updateToc() {
      var current = '';
      sections.forEach(function (s) {
        if (window.scrollY >= s.offsetTop - 120) current = s.id;
      });
      tocLinks.forEach(function (a) {
        a.classList.toggle('active', a.getAttribute('href') === '#' + current);
      });
    }
    window.addEventListener('scroll', updateToc, { passive: true });
    updateToc();
  }
  /* SMOOTH SCROLL */
  document.querySelectorAll('.lc-toc a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});